import { Component, HostListener, OnInit } from '@angular/core';
import { EmployeesapService } from 'src/app/home/services/employeesap.service';
import { EmployeeSap } from 'src/app/home/models/employee.interface';

@Component({
  selector: 'app-planes',
  templateUrl: './planes.component.html',
  styleUrls: ['./planes.component.scss'],
})
export class PlanesComponent implements OnInit {
  dropdownOpen = false;
  countAdultos = 0;
  countHijos = 0;
  countOtros = 0;
  showSalaryEye = true;
  recommendedPlan = '';
  personalPlan = false;
  familyPlan = false;
  duoPlan = false;
  employeeSap!: EmployeeSap;

  constructor(
    private employeeSapService: EmployeesapService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.employeeSap = await this.employeeSapService.getEmployeeSapByRut();
  }

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    if (!this.dropdownOpen) {
      return;
    }

    const target = event.target as HTMLElement;
    const dropdownElement = document.getElementById('dropdownBenefit');

    if (dropdownElement != null && !dropdownElement.contains(target)) {
      this.dropdownOpen = false;
    }
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  increment(section: string) {
    if (section === 'adultos') {
      this.countAdultos++;
    } else if (section === 'hijos') {
      this.countHijos++;
    } else if (section === 'otros') {
      this.countOtros++;
    }
  }

  decrement(section: string) {
    if (section === 'adultos' && this.countAdultos > 0) {
      this.countAdultos--;
    } else if (section === 'hijos' && this.countHijos > 0) {
      this.countHijos--;
    } else if (section === 'otros' && this.countOtros > 0) {
      this.countOtros--;
    }
  }

  showSalary() {
    this.showSalaryEye = !this.showSalaryEye;
  }

  recommendPlan() {
      const esPlanPersonal = this.countAdultos === 0 && this.countHijos === 0 && this.countOtros === 0;
      const esDuoPlan = this.countAdultos === 1 && this.countHijos === 0 && this.countOtros === 0;
      const esPlanFamiliar = 
        (this.countAdultos === 0 && (this.countHijos > 0 || this.countOtros > 0)) ||
        (this.countAdultos >= 1 && (this.countHijos >= 1 || this.countOtros >= 1)) ||
        (this.countAdultos >= 2);
    
      this.personalPlan = esPlanPersonal;
      this.duoPlan = esDuoPlan;
      this.familyPlan = esPlanFamiliar;

      if (esPlanPersonal) {
        this.recommendedPlan = 'Plan Personal';
      } else if (esDuoPlan) {
        this.recommendedPlan = 'Plan Duo';
      } else if (esPlanFamiliar) {
        this.recommendedPlan = 'Plan Familiar';
      } else {
        this.recommendedPlan = '';
      }
  }

  salaryUserSap() {
    const sueldoBruto = this.employeeSap.colaborador.condiciones;
    for (const sb of sueldoBruto) {
      return sb.sueldoBruto;
    }
    return 0;
  }

  scrollToSection(): void {
    const element = document.getElementById('idplanes');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
